import { qreq } from "../../shared/qrequest";
import BaseCom from "../BaseCom";
import Card from "../Card";
import Switch from "../Switch";

export default class AccountPricingManager extends BaseCom {
    async componentDidMount() {
        await this.load();
    }

    async componentDidUpdate(prevProps) {
        if (this.props.account?.id !== prevProps.account?.id) {
            await this.load();
        }
    }

    load = async () => {
        if (!this.props.account)
            return;
        try {
            let j = await qreq.postAsync('/api/product/list', {});
            if (j.list) {
                j.list.forEach(p => {
                    let attr = this.props.account?.productAttributes?.find(ap => ap.productID === p.id);
                    if (!attr)
                        return;
                    let price = attr?.price;
                    let upfrontFee = attr?.upfrontFee;
                    if (price)
                        p.customPrice = price;
                    if (p.customPrice === 0)
                        p.customPrice = null;
                    if (upfrontFee)
                        p.upfrontFee = upfrontFee;
                    if (p.upfrontFee === 0)
                        p.upfrontFee = null;
                    p.isActive = attr?.isActive;
                });
                j.list.sort((a, b) => a.productName.localeCompare(b.name));
                this.setState({ productList: j.list });
            }
            else
                this.alert(j.errorMessage);
        }
        catch (e) {
            console.error(e);
        }
    }

    changePrice = (e, product) => {
        let val = e.target.value;
        if (val)
            product.customPrice = e.target.value;
        else
            product.customPrice = 0;
        this.setState({ productList: [...this.state.productList] });
        this.props.onPriceChange(product);
    }

    changeUpfrontFee = (e, product) => {
        let val = e.target.value;
        if (!val)
            val = 0;
        product.upfrontFee = val;
        this.setState({ productList: [...this.state.productList] });
        this.props.onPriceChange(product);
    }

    changeIsActive = (e, product) => {
        let val = e.target.checked;
        product.isActive = val;
        this.setState({ productList: [...this.state.productList] });
        this.props.onPriceChange(product);
    }

    render() {
        return (
            <Card title="Pricing Manager">
                <table className="table table-striped">
                    <thead>
                        <tr>
                            <th>Manufacturer</th>
                            <th>Product</th>
                            {/*<th>Size</th>*/}
                            <th>Units</th>
                            <th>Unit Price</th>
                            <th>Upfront Fee</th>
                            <th>Active</th>
                        </tr>
                    </thead>
                    <tbody>
                        {this.state.productList?.map((p, idx) => (
                            <tr key={idx}>
                                <td>{p.manufacturer}</td>
                                <td>{p.productName}</td>
                                <td>{p.units}</td>
                                {/*<td>{p.productSize}</td>*/}
                                <td><input
                                    value={p.customPrice}
                                    type="number"
                                    step="0.01"
                                    className="form-control"
                                    onChange={(e) => this.changePrice(e, p)}
                                /></td>
                                <td>
                                    <input
                                        value={p.upfrontFee}
                                        type="number"
                                        step="0.01"
                                        className="form-control"
                                        onChange={(e) => this.changeUpfrontFee(e, p)}
                                    />
                                </td>
                                <td>
                                    <Switch
                                        checked={p.isActive}
                                        onChange={(e) => {
                                            this.changeIsActive(e, p);
                                        }} />
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </Card>
        );
    }
}